import React, { useState } from 'react'
import { handleDepartmentLogOut } from '../../HelperMethods';
import { useLocation, useNavigate } from 'react-router-dom';
import { departmentSidebarData } from '../../Data';
import Cookies from "js-cookie";

const MainHeader = ({ onMenuToggle }) => {
    const navigate = useNavigate();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const location = useLocation();
    const handleLogout = () => {
        handleDepartmentLogOut();
        navigate('/departmentlogin');
        setIsDropdownOpen(false);
    };

    const currentHeaderPath = location?.pathname?.split("/")?.[2]?.toLowerCase()

    const userName =   Cookies.get("DP_NIGHT_EYE_USER_NAME") || "D";               // ← Change as needed
    const initials = userName
        .split(' ')
        .map(word => word[0])
        .join('')
        .slice(0, 2)
        .toUpperCase();                     // e.g. "VD" or "JS"

    return (
        <header className="flex items-center justify-between whitespace-nowrap border-b border-solid border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 px-6 py-3 h-16 shrink-0 z-10">
            <div className="flex items-center gap-4">
                <div className="flex items-center gap-4 md:hidden">
                    <button
                        onClick={onMenuToggle}
                        className="p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800"
                        aria-label="Open menu"
                    >
                        <span className="material-symbols-outlined text-2xl">menu</span>
                        {/* or hamburger icon of your choice */}
                    </button>
                </div>
                <div className="flex items-center justify-center size-8 rounded bg-primary/10 text-primary dark:bg-primary/20">
                    <span className="material-symbols-outlined text-[20px]">{departmentSidebarData?.filter(ele => ele.path.toLowerCase() === currentHeaderPath)?.[0]?.icon}</span>
                </div>
                <h2 className="text-slate-900 dark:text-white text-lg font-bold leading-tight tracking-tight">{departmentSidebarData?.filter(ele => ele.path.toLowerCase() === currentHeaderPath)?.[0]?.label}</h2>
            </div>
            <div className="relative  flex items-center justify-center flex gap-2">
             
                <button
                    type="button"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    className="flex items-center  gap-3 focus:outline-none"
                >
                    {/* Avatar with initials */}
                    <div className="h-10 w-10 rounded-full bg-indigo-600 text-white flex items-center justify-center font-medium text-sm ring-2 ring-white dark:ring-gray-800 shadow-sm">
                        {initials}
                    </div>

                </button>

                {/* Dropdown Menu */}
                {isDropdownOpen && (
                    <>
                        {/* Backdrop (mobile friendly close) */}
                        <div
                            className="fixed inset-0 z-30 md:hidden"
                            onClick={() => setIsDropdownOpen(false)}
                        />

                        <div className="
              absolute right-0 top-full mt-2 w-56 
              bg-white dark:bg-gray-800 
              rounded-lg shadow-xl border border-gray-200 dark:border-gray-700
              overflow-hidden z-40
              origin-top-right
              animate-in fade-in zoom-in-95 duration-150
            ">
                            <div className="py-1.5 px-4 border-b border-gray-100 dark:border-gray-700">
                                <p className="text-sm font-medium text-gray-900 dark:text-white">
                                    {userName}
                                </p>
                                <p className="text-xs text-gray-500 dark:text-gray-400">
                                    Department
                                </p>
                            </div>

                            <button
                                onClick={handleLogout}
                                className="
                  w-full text-left px-4 py-2.5 text-sm
                  text-red-600 dark:text-red-400 
                  hover:bg-gray-50 dark:hover:bg-gray-700/70
                  transition-colors
                "
                            >
                                Log Out
                            </button>
                        </div>
                    </>
                )}
            </div>

        </header>
    )
}

export default MainHeader
